import { render, staticRenderFns } from "./FAQContainer.vue?vue&type=template&id=512aa314&"
import script from "./FAQContainer.vue?vue&type=script&lang=js&"
export * from "./FAQContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports